
<PoppinsCheckbox
  v-model="form.termsAccepted"
  name="termsAccepted"
  checkboxId="terms-of-service"
  labelClass="mb-0"
  :formattedLabelText="`I agree to the <a target='_blank' href='${termsOfUseLink}' class='text-grey-clickable underline sign-up-form-link'>Terms of Use</a>. For details on collection and use of your information, see our <a target='_blank' href='${privacyPolicyLink}' class='text-grey-clickable underline sign-up-form-link'>Privacy Policy</a>.`"
  :status="formStatuses.termsAccepted"
  :helperText="helperText(formStatuses.termsAccepted)"
  :required="true"
  @blur="validate"
/>
